import React from "react";
import { useDispatch } from "react-redux";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { hitGetSettingsApi } from "../../../Redux/Common/GetSettingsSlice";

const TermServiceWeb = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [text, setText] = React.useState("");
  useEffect(() => {
  
      dispatch(hitGetSettingsApi()).then((response) => {
        if (response.payload && response.payload.status === true) {
          setText(response.payload.data.termsOfServiceText);
        }
      });
    
  }, [dispatch, navigate]);

  return (
    <>
      <div className="PrivacyPolicy-container">
      <div className="custom_container">

        <h1 className="page-title">Terms of Service</h1>

        <div className="warning-card"  dangerouslySetInnerHTML={{ __html: text }}>
        </div>
      </div>
      </div>
    </>
  );
};

export default TermServiceWeb;
